import React from 'react';
import { View } from 'react-native';
import Modal from './ModalFinal';
import { ImageLoading } from './ImageLoading';

interface IFullViewLoader{
    showLoading:boolean;
    removeBackground:boolean;
}

const FullViewLoader=(props:IFullViewLoader)=>{

    const { showLoading,removeBackground } = props;

    return (
        <Modal style={{margin:0,marginHorizontal:"auto"}} removeBackground={removeBackground} onBackdropPress={()=>{}} isVisible={showLoading} layout='fit-content' >
            <View style={{flex:1,justifyContent:"center",alignItems:"center"}}>
                <ImageLoading />
            </View>
        </Modal>
    )
}

export default FullViewLoader;